export default {
    title: '매일국어 T 各活动指南汇总',
};
